<template>
  <div
    :class="`tile ${sizeMap[size]}-tile`"
    :style="{ backgroundImage: `url(${image})` }"/>
</template>

<script setup>
defineProps({
  size: {
    type: String,
    required: true,
    validator: (value) => ['s', 'm', 'l'].includes(value)
  },
  image: {
    type: String,
    required: true
  }
})
const sizeMap = {
  s: 'small',
  m: 'medium',
  l: 'large'
}
</script>

<style lang="scss" scoped>
.tile {
  height: auto;
  // remove opacity when we have actual images
  opacity: 0.5;
  background-size: cover;
  background-position: center;
}
.small-tile {
  aspect-ratio: 90 / 119;
  width: 100%;
  height: auto;
}
.medium-tile {
  aspect-ratio: 90 / 155;
  width: 100%;
  height: auto;
}
.large-tile {
  aspect-ratio: 90 / 215;
  width: 100%;
  height: auto;
}
</style>